import { render } from "./AtlasSignature.vue?vue&type=template&id=af1d35ce&scoped=true"
import script from "./AtlasSignature.vue?vue&type=script&lang=js"
export * from "./AtlasSignature.vue?vue&type=script&lang=js"

import "./AtlasSignature.vue?vue&type=style&index=0&id=af1d35ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1d35ce"]])

export default __exports__